import { AxiosHelper } from "../axiosConfig";
import APIConstant from "../utils/apiConstant";

import {
  ILiftOffDiagnosticTest,
  ILiftOffDiagnosticTestQuestion,
} from "../model/interface/liftOffDiagnosticTest";

export const saveLFDiagnosticTest = (
  lfDiagnosticTest: ILiftOffDiagnosticTest,
  lfDiagnosticTestQuestions: Array<ILiftOffDiagnosticTestQuestion>
) => {
  return AxiosHelper.axiosInstance().post(
    `${APIConstant.CMS_LIFTOFFDIAGNOSTICTEST}`,
    {
      liftOffDiagnosticTest: lfDiagnosticTest,
      liftOffDiagnosticTestQuestions: lfDiagnosticTestQuestions,
    },
    {}
  );
};

export const getLFDiagnosticTest = (lfHeaderId: number, subjectId: number) => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_LIFTOFFDIAGNOSTICTEST}`,
    {
      params: {
        liftOffHeaderId: lfHeaderId,
        subjectId: subjectId,
      },
    }
  );
};

export const deleteLFDiagnosticTest = (
  lfDiagTestId: number,
  userId: number
) => {
  return AxiosHelper.axiosInstance().delete(
    `${APIConstant.CMS_LIFTOFFDIAGNOSTICTEST}`,
    {
      params: {
        liftoffDiagnosticTestId: lfDiagTestId,
        userId: userId,
      },
    }
  );
};
